import services from '../services'

export const ActionIndex = (context, params) => {
    return services.index(params)
}

export const ActionShow = (context, id) => {
    return services.show(id)
}

export const ActionStore = (context, data) => {
    return services.store(data)
}

export const ActionUpdate = (context, data) => {
    return services.update(data)
}

export const ActionDestroy = (context, id) => {
    return services.destroy(id)
}
